import { z } from 'zod';
import { mediaIdSchema, type MediaSummary } from './content';

/**
 * Personalise: a profile says "I like this" or "I don't like this" to a stream of movies, in setup
 * or Settings → Personalise Feed, and Home's suggestions follow what it said.
 */
export const personaliseAnswerSchema = z.object({
  mediaId: mediaIdSchema,
  liked: z.boolean(),
  /** The title as it was shown, so Settings can list answers without asking the catalogue. */
  snapshot: z
    .object({
      title: z.string().max(300),
      year: z.number().int().nullable().optional(),
      posterUrl: z.string().max(2000).nullable(),
      genres: z.array(z.string().max(60)).max(20).optional(),
    })
    .optional(),
});
export type PersonaliseAnswerInput = z.infer<typeof personaliseAnswerSchema>;

export const personaliseNextQuerySchema = z.object({
  /** Where the last batch stopped in the catalogue (from its `cursor`). */
  cursor: z.coerce.number().int().min(0).max(100_000).default(0),
  /** Titles the app is already showing, comma separated. */
  exclude: z.string().max(4000).optional(),
});

/** The next movies to answer: never one this profile has already answered. */
export interface PersonaliseBatch {
  items: MediaSummary[];
  /** Pass back as `cursor` for the batch after this one. */
  cursor: number;
  /** The catalogue has nothing more to show. */
  done: boolean;
}

export interface PersonaliseSummary {
  liked: number;
  disliked: number;
  /** When the last answer was given, or null when there are none. */
  updatedAt: string | null;
}
